<div class="d-flex">
  <div class="max-width-300  flex-column mg-r-30">

    <h3 class="first">{{utils.getTotalRecordsLabel('point de livraison', pointsDeLivraisonListUsed?.length)}} </h3>
    <p-listbox [options]="pointsDeLivraisonListUsed" [(ngModel)]="selectedPointDeLivraison"
               [style]="{'width':'260px'}"
               (onChange)="loadRepasCatalogue()"
               [listStyle]="{'max-height':'71vh','min-height':'71vh'}"
               filter="filter" optionLabel="libelle">
      <ng-template let-item pTemplate="item">
        <i class="fas fa-map-pin mg-r-5 pn-border-color"></i>{{item.libelle}}
      </ng-template>
      <ng-template pTemplate="header">
        <span class="mg-r-5">
          <button pButton pTooltip="Ajouter un point de livraison"
                  tooltipPosition="top"
                  showDelay="500"
                  class="mg-r-5"
                  icon="fas fa-plus"
                  class="p-button-secondary"
                  (click)="displayDialogAddPlc()">
          </button>
        </span>

        <span class="mg-r-5">
          <button pButton pTooltip="Supprimer un point de livraison"
                  tooltipPosition="top"
                  showDelay="500"
                  class="p-button-secondary mg-r-5"
                  icon="fas fa-minus"
                  (click)="displayDialogRemovePlc()"
                  [disabled]="utils.isCollectionNullOrEmpty(pointsDeLivraisonListUsed)">
          </button>
        </span>

      </ng-template>
    </p-listbox>
  </div>
  <div class="d-flex  flex-column repas-setting">
    <div class="d-flex justify-content-between action-bar ">
      <div>
        <button pButton
                pTooltip="Ajouter un repas"
                tooltipPosition="top"
                [disabled]="pointsDeLivraisonListUsed.length === 0"
                showDelay="500"
                class=" mg-r-5"
                (click)="displayDialogAddRepas($event)"
                icon="fas fa-plus">
        </button>
        <button pButton
                pTooltip="Supprimer un repas"
                tooltipPosition="top"
                showDelay="500"
                [disabled]="pointsDeLivraisonListUsed.length === 0"
                class=" mg-r-5"
                (click)="displayDialogRemoveRepas($event)"
                icon="fas fa-minus">
        </button>
      </div>
      <span class="genlabel font-12 pd-t-10" *ngIf="repasListUsed.length === 0">
          <i class="fas fa-exclamation-triangle danger-color mg-r-5"></i>
          Aucun repas disponible pour ce point de livraison
      </span>
      <div>
        <!--        <yo-button-save-->
        <!--          (onClick)="savePlc()"-->
        <!--          yoType="submit">-->
        <!--        </yo-button-save>-->
      </div>
    </div>
    <div *ngIf="selectedPointDeLivraison">
      <p-tabMenu [model]="tabMenuRepasList" [activeItem]="activeRepas"></p-tabMenu>
      <p-card>
        <div class="size-card">
          <!-- todo mettre un  <router-outlet></router-outlet> -->
        </div>
      </p-card>
    </div>

  </div>
</div>


<!--DIALOG DE SELECTION DES POINTS DE LIVRAISON-->
<p-dialog
  [modal]="true"
  [dismissableMask]="false"

  [style]="{'width':'600px'}"
  positionTop="75"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayPlcAddDialog">


  <!--TITRE-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-map-pin mg-r-5"></i> Ajouter des points de livraison
    </div>
  </ng-template>


  <!--CONTENT-->
  <p-listbox [(ngModel)]="selectedPointsDeLivraisonToAdd"
             multiple="multiple"
             checkbox="checkbox"
             filter="filter"
             [style]="{'width':'556px'}"
             [listStyle]="{'max-height':'650px','width':'550px','min-width':'550px'}"
             [options]="pointsDeLivraisonToAdd"
             optionLabel="libelle">
    <ng-template let-item let-i="index" pTemplate="item">
      <i class="fas fa-map-pin mg-r-5"></i>   {{item.libelle}} <span
      class="genlabel font-12">({{item.adresse.ville}})</span>
    </ng-template>
  </p-listbox>

  <span class="genlabel font-10" *ngIf="pointsDeLivraisonToAdd.length>1">{{pointsDeLivraisonToAdd.length}} points de livraison disponibles</span>
  <span class="genlabel font-12" *ngIf="pointsDeLivraisonToAdd.length<1"><i
    class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun point de livraison disponible</span>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <button pButton icon="fas fa-check" pTooltip="Ajouter les points de livraison sélectionnés" showDelay="500"
                class="mg-r-5"
                (click)="attachSelectedPointsDeLivraison($event)"></button>
        <button pButton icon="fas fa-times" (click)="displayPlcAddDialog=false"
                class="p-button-secondary"></button>
      </div>
    </div>

  </ng-template>

</p-dialog>

<!--DIALOG DE SUPPRESSION DES POINTS DE LIVRAISON-->
<p-dialog
  [modal]="true"
  [dismissableMask]="false"

  [style]="{'width':'600px'}"
  positionTop="75"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayPlcRemoveDialog">

  <!--TITRE-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-map-pin mg-r-5"></i> Supprimer des points de livraison
    </div>
  </ng-template>


  <!--CONTENT-->
  <p-listbox [(ngModel)]="selectedPointsDeLivraisonToRemove"
             multiple="multiple"
             checkbox="checkbox"
             filter="filter"
             [style]="{'width':'556px'}"
             [listStyle]="{'max-height':'650px','width':'550px','min-width':'550px'}"
             [options]="pointsDeLivraisonToRemove"
             optionLabel="libelle">
    <ng-template let-item let-i="index" pTemplate="item">
      <i class="fas fa-map-pin mg-r-5"></i>   {{item.libelle}} <span
      class="genlabel font-12">({{item.adresse.ville}})</span>
    </ng-template>
  </p-listbox>

  <span class="genlabel font-10" *ngIf="pointsDeLivraisonToRemove.length>1">{{pointsDeLivraisonToRemove.length}} points de livraison à supprimer</span>
  <span class="genlabel font-12" *ngIf="pointsDeLivraisonToRemove.length<1"><i
    class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun point de livraison à supprimer</span>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <button pButton icon="fas fa-check"
                pTooltip="Supprimer les points de livraison sélectionnés"
                showDelay="500"
                class="mg-r-5"
                (click)="detachSelectedPointsDeLivraison($event)"></button>
        <button pButton icon="fas fa-times" (click)="displayPlcRemoveDialog=false"
                class="p-button-secondary"></button>
      </div>
    </div>

  </ng-template>

</p-dialog>


<!--DIALOG DE SELECTION DES REPAS-->
<p-dialog
  [modal]="true"
  [dismissableMask]="false"

  [style]="{'width':'600px'}"
  positionTop="75"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayRepasAddDialog">


  <!--TITRE-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-utensils mg-r-5"></i>Ajouter des repas au point de
      livrasion {{selectedPointDeLivraison.libelle}}
    </div>
  </ng-template>


  <!--CONTENT-->
  <p-listbox [(ngModel)]="selectedRepasToAdd"
             multiple="multiple"
             checkbox="checkbox"
             [style]="{'width':'556px'}"
             [listStyle]="{'max-height':'650px','width':'550px','min-width':'550px'}"
             [options]="repasToAdd"
             optionLabel="libelle">
    <ng-template let-item let-i="index" pTemplate="item">
      <i class="fas fa-utensils mg-r-5"></i>   {{item.libelle}}
    </ng-template>
  </p-listbox>
  <span class="genlabel font-12" *ngIf="repasToAdd.length<1"><i
    class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun repas disponible
  </span>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <button pButton icon="fas fa-check" pTooltip="Ajouter les repas a votre point de livraison" showDelay="500"
                class="mg-r-5"
                (click)="attachSelectedRepas()"></button>
        <button pButton icon="fas fa-times" (click)="displayRepasAddDialog=false"
                class="p-button-secondary"></button>
      </div>
    </div>

  </ng-template>
</p-dialog>

<!--DIALOG DE SUPPRESSION DES REPAS-->
<p-dialog
  [modal]="true"
  [dismissableMask]="false"

  [style]="{'width':'600px'}"
  positionTop="75"
  appendTo="body"
  [contentStyle]="{'overflow':'visible'}"
  [(visible)]="displayRepasRemoveDialog">

  <!--TITRE-->
  <ng-template pTemplate="header">
    <div class="p-dialog-title">
      <i class="fas fa-map-pin mg-r-5"></i> Supprimer les repas du point de
      livraison {{selectedPointDeLivraison.libelle}}
    </div>
  </ng-template>


  <!--CONTENT-->
  <p-listbox [(ngModel)]="selectedRepasToRemove"
             multiple="multiple"
             checkbox="checkbox"
             filter="filter"
             [style]="{'width':'556px'}"
             [listStyle]="{'max-height':'650px','width':'550px','min-width':'550px'}"
             [options]="repasToRemove"
             optionLabel="libelle">
    <ng-template let-item let-i="index" pTemplate="item">
      <i class="fas fa-utensils mg-r-5"></i>   {{item.libelle}}
    </ng-template>
  </p-listbox>

  <span class="genlabel font-10" *ngIf="repasToRemove.length>1">{{repasToRemove.length}}
    points de livraison à supprimer</span>
  <span class="genlabel font-12" *ngIf="repasToRemove.length<1"><i
    class="fas fa-exclamation-triangle danger-color mg-r-5"></i> Aucun point de livraison à supprimer</span>

  <!--FOOTER-->
  <ng-template pTemplate="footer">
    <div class="row">
      <div class="col-md-12 text-right">
        <button pButton icon="fas fa-check" pTooltip="Supprimer les repas selectionnés" showDelay="500"
                class="mg-r-5"
                (click)="detachSelectedRepas($event)"></button>
        <button pButton icon="fas fa-times" (click)="displayRepasRemoveDialog=false"
                class="p-button-secondary"></button>
      </div>
    </div>

  </ng-template>

</p-dialog>
